import axios from 'axios';
import { Order } from 'views/order-feed/features/my-supply-plan/features/ofd-1.0/types/order.type';
import { Recommendation } from 'views/order-feed/features/my-supply-plan/features/ofd-1.0/types/recommendation.type';

// GET
// /ewosapi/v2/order/history/orderheads/{customerNumber}/{orderNumber}
export const getOrder = async (customerNumber: string, orderNumber: string): Promise<Order> => {
  //   return OrderData;
  const res = await axios.get(`/ewosapi/v2/order/history/orderheads/${customerNumber}/${orderNumber}`);
  return res.data;
};

// GET
// /ewosapi/v1/order/recommended/{globalCompanyId}
export const getRecommendation = async (globalCompanyId: string): Promise<Recommendation> => {
  // return OrderRecommendedData;
  const res = await axios.get(`/ewosapi/v1/order/recommended/${globalCompanyId}`);
  return res.data;
};
